import { render, staticRenderFns } from "./FormulaBlock.vue?vue&type=template&id=56b83ac7&scoped=true&"
import script from "./FormulaBlock.vue?vue&type=script&lang=js&"
export * from "./FormulaBlock.vue?vue&type=script&lang=js&"
import style0 from "./FormulaBlock.vue?vue&type=style&index=0&id=56b83ac7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b83ac7",
  null
  
)

export default component.exports